$('.questions-t .qt[data-type=2]').each(function (i, q) {
	let $words = $(q).find('span.word');

	$words.on('dragstart', function (e) {
		$(this).addClass('moving');
	}).on('dragend', function (e) {
		$(this).removeClass('moving');
	}).on('touchstart', function (e) {
		$(this).addClass('moving');
	}).on('touchend', function (e) {
		let x = e.originalEvent.changedTouches[0].clientX;
		let y = e.originalEvent.changedTouches[0].clientY;

		let elemFromPoint = document.elementFromPoint(x, y);
		let $elemFromPoint = $(elemFromPoint);
		if ($elemFromPoint.hasClass('word-holder-input')) {
			$elemFromPoint.closest('.word-holder').trigger('drop');
		}

		$(this).removeClass('moving');
	}).on('touchmove', function (e) {
		let xPage = e.originalEvent.changedTouches[0].pageX;
		let xClient = e.originalEvent.changedTouches[0].clientX;
		let yPage = e.originalEvent.changedTouches[0].pageY;
		let yClient = e.originalEvent.changedTouches[0].clientY;

		$(this).css({
			'left': xPage + 20,
			'top': yPage - 300,
		});

		let elemFromPoint = document.elementFromPoint(xClient, yClient);
		let $elemFromPoint = $(elemFromPoint);
		if ($elemFromPoint.hasClass('word-holder-input')) {
			$elemFromPoint.closest('.word-holder').addClass('dragover');
		}

		$(q).find('.word-holder').not($elemFromPoint.closest('.word-holder')).removeClass('dragover');

		return false;
	});

	$(q).find('.word-holder').on('dragover', function (e) {
		e.preventDefault();
		$(this).addClass('dragover');
	}).on('dragleave', function (e) {
		$(this).removeClass('dragover');
	}).on('drop', function (e) {
		$(this).removeClass('dragover');
		let $activeElement = $words.filter('.moving');

		if ($activeElement.length) {
			let $target = $(e.delegateTarget);
			let $input = $target.find('input');

			if ($input.val())
				return false;

			$activeElement.hide();
			$input.attr('value', $activeElement.text());
			$input.attr('data-index', $activeElement.data('index'));
		}

		Lection.cacheHomework();
	});

	$(q).find('.word-holder .btn-del').click(function () {
		let $input = $(this).closest('.word-holder').find('input');
		let ind = $input.attr('data-index');
		let $qt = $(this).closest('.qt');

		$input.attr('value', '');
		$input.attr('data-index', '');
		$qt.find('.words .word[data-index="' + ind + '"]').show();

		Lection.cacheHomework();

		return false;
	});
});